export const externalApplicationFailedMock = {
  appId: 'iosimplus',
};
